import React from "react"
const Footer = () => {
    return (

          <footer className={`footer`}>
              <div className={`container footer__wrapper clearfix`}>
                  <div className={`footer__left clearfix`}>
                      © 2009 - {new Date().getFullYear()}{' '}
                      <a href="https://ventraip.com.au/" target={'_blank'}>VentraIP Australia</a>
                  </div>
                  <div className={`footer__right clearfix`}>
                      <ul>
                          <li>
                              <a href={'https://ventraip.com.au/terms-policies-agreements/'} target={`_blank`}>Privacy Policy</a>
                          </li>
                          <li>
                              <a href={'https://ventraip.com.au/terms-policies-agreements/'} target={`_blank`}>Terms of Services</a>
                          </li>
                      </ul>
                  </div>
              </div>
          </footer>

  )
}


export default Footer
